import CaseStudies from './case-studies';

export default CaseStudies;
